import {mapGetters} from 'vuex'
import {getName} from '@/utils/disaster'

export default {
  name: 'ReportsSection',
  computed: {
    ...mapGetters('Dashboard', ['reports']),
  },
  methods: {
    startTime (i) {
      const str = new Date(i.time.start).toGMTString()
      return str.slice(0, -7)
    },
    endTime (i) {
      const str = new Date(i.time.end).toGMTString()
      return str.slice(0, -7)
    },
    disasterName (i) {
      return getName(i.type)
    }
  }
}